import React from 'react';
import { ShowItem } from '../classes/showItem';
import ShowItems from './ShowItems';
import Progress from './Progress';
import { ErrorDialogContext } from './ErrorDialog';
import { useSystemState } from '../SystemState';
import AwareLegend from './AwareLegend';
import AllergiesInfo from './AllergiesInfo';

interface DrugsPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function DrugsPanel(props: DrugsPanelProps) {
  const { children, value, index, ...other } = props;

  const [drugs, setDrugs] = React.useState<ShowItem[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const state = useSystemState();

  const errorDialogCtx = React.useContext(ErrorDialogContext);

  React.useEffect(() => {
    setLoading(true);
    state.drugs.then((res) => {
      setDrugs(res.getItems());
      setLoading(false);
    }).catch((err) => {
      errorDialogCtx?.setContent(err.message);
      errorDialogCtx?.setOpen(true);
      setLoading(false);
    });
  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <React.Fragment>
          { loading && <Progress />}
          <AllergiesInfo />
          <AwareLegend />
          <ShowItems items={drugs} urlPrefix='/list' showScrollToTop />
        </React.Fragment>
      )}
    </div>
  );
}

export default DrugsPanel;
